export default "/static/image/lanhu/modal/close.webp"